import ServerErrorComponent from './server-error.component'

const ServerErrorModule = angular.module('cdbl.server-error', [

])
  .component('cdblServerError', ServerErrorComponent)
  .name

export default ServerErrorModule
